































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { HeaderData } from '../classes/HeaderData';
import { date, localize } from '@/core/filters';
import { DataCategory, LocalizationKeys } from '../classes';
import { CultureState } from '@/store';
import DataSource from 'devextreme/data/data_source';
import { ResourceTypeTree } from '@/dto';
import { ContextsState } from '@/store';
import {
    CONTRACTS,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import FilterSelector from '@/pages/operationalPlanSummary/components/FilterSelector.vue';
import { getParentId } from '@/core/components/tree/treeHelpers';

@Component({
    filters: {
        date,
    },
    components: {
        FilterSelector
    }
})
export default class Header extends Vue {
    @Prop({ required: true, })
    public headerData?: HeaderData;

    public DataCategory = DataCategory;
    public LocalizationKeys = LocalizationKeys;

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    private filterShown: boolean = false;

    private mounted(): void {
        if (!this.headerData) { throw new Error('headerData is not set'); }
    }

    public get today(): string {

        let result;

        const today = this.headerData!.today;
        if (today) {
            result = today.format({
                day: '2-digit',
                month: 'long',
                year: 'numeric',
            });
        } else {
            result = '';
        }

        return result;
    }
    public get isLoaded(): boolean {
        return this.headerData!.isFirstStageLoaded;
    }

    private onFilterSelected(filter: any) {
        this.$emit('onFilterSelected', filter);
    }

    private showFilters() {
        const name = 'filterInstance';
        const filter = this.$refs[name] as FilterSelector;
        filter.showPopUp();
    }

    private isDataCategorySelected(category: DataCategory): boolean {
        return this.headerData!.selectedDataCategory === category;
    }

    private onCategoryClick(category: DataCategory): void {
        this.selectCategory(category);
    }

    private selectCategory(category: DataCategory): void {
        this.headerData!.selectCategory(category);
    }

    private get localizePlaceholder() {
        return localize('PlaceholderAnyResourceType');
    }

    private get resourceTypeDataSource() {
        return new DataSource({
            loadMode: 'processed',
            key: 'treeId',
            load: this.load
        });
    }

    private async load(parameters: any) {
        const currentContextId = ContextsState.currentContextId;
        const parentId = parameters && parameters.filter ? getParentId(parameters.filter) : '';
        const url = `/contexts/${currentContextId}/resourceTypesList/${parentId}`;
        return await this._fetchService!.get<ResourceTypeTree[]>(url);
    }

    private getloadSelectedItemsHandler(): (items: any) => Promise<any[]> {
        return (items: any) => {
            return this.loadSelectedItems(items);
        };
    }

    private async loadSelectedItems(items: any) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/contexts/${currentContextId}/resourceTypesList/selected/${items}`;
        const data = await this._fetchService!.get<ResourceTypeTree[]>(url);

        return data;
    }
}
